import * as React from 'react';
import { useZustand } from 'use-zustand';
import { pathwayStore } from './store';
import { Config } from './helper';
import { fetchConfig, fetchPathwayProgress, fetchUserState } from './api';

export function useLearningPathway(id) {
  const {
    description,
    updateComponentState,
    updateDescription,
    updateSteps,
    updateBreadcrumbs,
    updateUserState,
    updateUserProgress,
    updatePathwayID,
  } = useZustand(pathwayStore, (state) => {
    return {
      description: state.description,
      updateComponentState: state.updateComponentState,
      updateDescription: state.updateDescription,
      updateSteps: state.updateSteps,
      updateBreadcrumbs: state.updateBreadcrumbs,
      updateUserState: state.updateUserState,
      updateUserProgress: state.updateUserProgress,
      updatePathwayID: state.updatePathwayID,
    }
  });

  let pathwayID;
  React.useEffect(() => {
    fetchConfig(id)
      .then(data => {
        const {
          id,
          name,
          definition: {
            breadcrumbs = [],
            description = '',
            steps = [],
          },
        } = data;
        pathwayID = id;
        updatePathwayID(id);
        updateDescription(description);
        updateSteps(steps);
        updateBreadcrumbs(breadcrumbs)
        updateComponentState(Config.State.loaded);
      })
      .then(() => fetchPathwayProgress(pathwayID))
      .then(progressData => updateUserProgress(progressData))
      .then(fetchUserState)
      .then(userState => updateUserState(userState))
      .catch(error => {
        updateComponentState(Config.State.failed);
        updateUserState(Config.UserState.unknown);
      });
  }, []);

  return { description }
}
